/* eslint-disable eqeqeq */
export function isFunction(value) {
  return !!(value && {}.toString.call(value) == '[object Function]');
}